import React from 'react';
import './RegisterSkeleton.css';

const RegisterSkeleton = () => {
    return (
        <div className="skeleton-wrapper">
            {/* شبیه‌سازی مرحله 1 (تایید شماره) */}
            <div className="skeleton-box">
                <div className="sk-title" style={{ width: '40%', marginBottom: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className="sk-text" style={{ height: '55px', borderRadius: '12px' }}></div>
                <div className="sk-text" style={{ height: '15px', width: '70%', margin: '15px auto 0', borderRadius: '4px' }}></div>
            </div>

            {/* شبیه‌سازی مرحله 3 (فرم اطلاعات تکمیلی) */}
            <div className="skeleton-box">
                <div className="sk-title" style={{ width: '30%', marginBottom: '25px', height: '20px', borderRadius: '4px' }}></div>
                
                <div className="sk-text" style={{ height: '45px', marginBottom: '15px', borderRadius: '12px' }}></div>
                <div className="sk-text" style={{ height: '45px', marginBottom: '15px', borderRadius: '12px' }}></div>
                <div className="sk-text" style={{ height: '45px', marginBottom: '15px', borderRadius: '12px' }}></div>
                <div className="sk-text" style={{ height: '45px', marginBottom: '15px', borderRadius: '12px' }}></div>
                
                {/* شبیه‌سازی Textarea */}
                <div className="sk-text" style={{ height: '90px', marginBottom: '15px', borderRadius: '12px' }}></div>
                
                {/* شبیه‌سازی دکمه ثبت */}
                <div className="sk-btn" style={{ height: '50px', borderRadius: '12px', marginTop: '10px' }}></div>
            </div>
        </div>
    );
};

export default RegisterSkeleton;
